import React from 'react'

import { PlusCircle as PlusCircleIcon } from 'react-feather'
import { useHistory } from 'react-router-dom'
import { Button } from '@material-ui/core'

import { Container, ContentHeader, Page, Permitted } from 'components'

import { PmcTable } from './components'

import constants from 'constants/index'
import { routes } from 'Routes'

const PmcMain = () => {
  const history = useHistory()

  const redirectToCreate = () => history.push(routes.pmc.new)

  return (
    <Page title="Planos de melhorias contínuas (PMCs)">
      <Container maxWidth={false}>
        <ContentHeader title="Planos de melhorias contínuas (PMCs)">
          <Permitted
            tag={constants.permissions.MONITORING_MANAGEMENT_PMC.MANAGE}
          >
            <Button
              variant="contained"
              color="primary"
              startIcon={<PlusCircleIcon size={20} />}
              onClick={redirectToCreate}
              fullWidth
            >
              Criar
            </Button>
          </Permitted>
        </ContentHeader>
        <PmcTable />
      </Container>
    </Page>
  )
}

export default PmcMain
